import React, { useState } from 'react'
import {
  Button,
  Columns,
  Container,
  Heading,
  Icon,
  Message,
  Section,
  Tabs,
} from 'react-bulma-components'
import Layout from '../../components/layout/layout'
import LoginForm from '../../components/session/login-form'
import { useLocation } from 'react-router-dom'
import QrLoginForm from 'src/components/session/qr-login-form'
import { QrcodeIcon } from '@heroicons/react/outline'

const Login: React.FC = () => {
  const { state } = useLocation()
  const message = state?.message
  const isKioskLogin = state?.isKioskLogin
  const [loginMethod, setLoginMethod] = useState<'emailLogin' | 'qrLogin'>('qrLogin')

  return (
    <Layout>
      <Section size="medium">
        <Container>
          <Columns centered>
            <Columns.Column size={4}>
              {message && (
                <Message color={message.color}>
                  {message.header && <Message.Header>{message.header}</Message.Header>}
                  <Message.Body>{message.body}</Message.Body>
                </Message>
              )}
              {isKioskLogin ? (
                <>
                  <Heading>Créer un Kiosque</Heading>
                  <Tabs type="boxed">
                    <Tabs.Tab active={loginMethod === 'emailLogin'}>
                      <Button
                        color="ghost"
                        textColor={loginMethod === 'emailLogin' ? 'primary' : 'grey'}
                        onClick={() => setLoginMethod('emailLogin')}
                      >
                        Par Email
                      </Button>
                    </Tabs.Tab>
                    <Tabs.Tab active={loginMethod === 'qrLogin'}>
                      <Button
                        color="ghost"
                        textColor={loginMethod === 'qrLogin' ? 'primary' : 'grey'}
                        onClick={() => setLoginMethod('qrLogin')}
                      >
                        Par Qr Code
                      </Button>
                    </Tabs.Tab>
                  </Tabs>
                  {loginMethod === 'emailLogin' && (
                    <>
                      <LoginForm />
                    </>
                  )}
                  {loginMethod === 'qrLogin' && (
                    <>
                      <QrLoginForm />
                    </>
                  )}
                </>
              ) : (
                <>
                  <Heading>Login</Heading>
                  <LoginForm />
                </>
              )}
            </Columns.Column>
          </Columns>
        </Container>
      </Section>
    </Layout>
  )
}

export default Login
